export default class Consts {
    public static EmptyGuid: string = "00000000-0000-0000-0000-000000000000";
    public static monthNames = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
];

}

